<div class="document-repository-wrapper">
  <app-toolbar />

  <section class="feature-shell">
    <!-- Page header -->
    <div class="page-header">
      <p class="page-description">Easily preview and update documents.</p>
      @if (canReplaceFile) {
        <app-az-button
          data-testid="bcr-279-replace-file"
          [label]="'Replace File'"
          [icon]="'upload'"
          [iconPosition]="'left'"
          (click)="openUploadModal()"
        />
      }
    </div>

    <!-- Loading state -->
    @if (loading()) {
      <div class="loading-state" aria-live="polite" aria-label="Loading documents">
        <span class="material-symbols-outlined spinning">progress_activity</span>
      </div>
    }

    <!-- Error state -->
    @if (loadError()) {
      <div class="error-state" role="alert">{{ loadError() }}</div>
    }

    <!-- Document table -->
    @if (!loading() && !loadError()) {
      <app-az-table
        data-testid="bcr-171-document-table"
        [data]="displayDocuments"
        [columns]="columns"
        [actions]="actions"
        [emptyMessage]="'No documents found'"
        [clickable]="userPermissionsService.hasPstMemberRole()"
        (rowClick)="onDocumentRowClick($event)"
      />
    }
  </section>

  <app-footer />

  <app-az-document-update-modal
    [isOpen]="showUploadModal()"
    [documentTypes]="documentTypes"
    [allowedFileTypes]="['pdf']"
    [showCommentBox]="false"
    [disableDocumentTypeSelector]="false"
    [showNotificationStep]="false"
    [isUploading]="isProcessing()"
    (closed)="closeUploadModal()"
    (upload)="onUpload($event)"
  />

  <app-status-change-modal
    #uploadStatusModal
    [isOpen]="isStatusModalOpen()"
    [initialState]="'processing'"
    [title]="statusModalTitle()"
    [processingResultTitle]="statusModalProcessingTitle()"
    (closed)="closeStatusModal()"
  />
</div>
